<template>
  <div>
    <el-row :gutter="16">
      <el-col :xs="24" :sm="8" :md="8">
        <el-form-item label="CEP" prop="pessoa.enderecoPrincipal.cep">
          <el-input
            v-model="value.enderecoPrincipal.cep"
            v-mask="'#####-###'"
            @blur="fetchEnderecoByCep"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="16" :md="16">
        <el-form-item
          label="Logradouro"
          prop="pessoa.enderecoPrincipal.logradouro"
        >
          <el-input v-model="value.enderecoPrincipal.logradouro"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="16" class="row-align-bottom">
      <el-col :xs="24" :sm="12" :md="6">
        <el-form-item
          label="Número"
          prop="pessoa.enderecoPrincipal.numero"
          :required="!value.enderecoPrincipal.semNumero"
          ref="numeroFormItem"
        >
          <el-input
            v-model="value.enderecoPrincipal.numero"
            :disabled="value.enderecoPrincipal.semNumero"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12" :md="6" class="checkbox-col">
        <el-checkbox
          v-model="value.enderecoPrincipal.semNumero"
          @change="changeSemNumero"
          :label="'Sem Número'"
        ></el-checkbox>
      </el-col>
      <el-col :xs="24" :sm="12" :md="6">
        <el-form-item label="Complemento">
          <el-input v-model="value.enderecoPrincipal.complemento"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12" :md="6">
        <el-form-item label="Bairro" prop="pessoa.enderecoPrincipal.bairro">
          <el-input v-model="value.enderecoPrincipal.bairro"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="16">
      <el-col :xs="24" :sm="12">
        <el-form-item label="UF" prop="pessoa.enderecoPrincipal.uf">
          <el-select
            v-model="value.enderecoPrincipal.uf"
            placeholder="Selecione"
            @change="fetchMunicipios"
            filterable
            class="full-width"
          >
            <el-option
              v-for="uf in ufs"
              :key="uf.id"
              :label="uf.sigla"
              :value="uf.sigla"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item
          label="Município"
          prop="pessoa.enderecoPrincipal.municipioNome"
        >
          <el-select
            v-model="value.enderecoPrincipal.municipioId"
            placeholder="Selecione"
            filterable
            class="full-width"
            :loading="municipioSelectLoader"
            @change="updateMunicipioNome"
            ref="municipioSelect"
          >
            <el-option
              v-for="municipio in municipios"
              :key="municipio.id"
              :label="municipio.nome"
              :value="municipio.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";
import { FETCH_UFS, FETCH_MUNICIPIOS } from "@/store/actions.type";
import axios from "axios";

export default {
  name: "EnderecoNacional",
  directives: { mask },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      municipioSelectLoader: false
    };
  },
  computed: {
    ...mapGetters(["ufs", "municipios"])
  },
  mounted() {
    this.$store.dispatch(FETCH_UFS);
  },
  methods: {
    changeSemNumero() {
      if (this.value.enderecoPrincipal.semNumero) {
        this.value.enderecoPrincipal.numero = "";
      }
      this.$nextTick(() => {
        if (this.$refs.numeroFormItem) {
          this.$refs.numeroFormItem.validateMessage = "";
          this.$refs.numeroFormItem.validateState = undefined;
        }
      });
    },
    fetchMunicipios(uf) {
      this.municipioSelectLoader = true;
      this.value.enderecoPrincipal.municipioId = null;
      this.value.enderecoPrincipal.municipioNome = "";

      if (uf) {
        const selectedUf = this.ufs.find(u => u.sigla === uf);
        if (selectedUf) {
          this.$store
            .dispatch(FETCH_MUNICIPIOS, selectedUf.id)
            .finally(() => (this.municipioSelectLoader = false));
        } else {
          this.municipioSelectLoader = false;
        }
      } else {
        this.municipioSelectLoader = false;
      }
    },
    updateMunicipioNome(id) {
      if (id) {
        const mun = this.municipios.find(m => m.id === id);
        if (mun) {
          this.value.enderecoPrincipal.municipioNome = mun.nome;
          this.$emit(
            "validate-field",
            "pessoa.enderecoPrincipal.municipioNome"
          );
          // Força atualização visual
          this.$forceUpdate();
        }
      }
    },
    fetchEnderecoByCep() {
      const cep = this.value.enderecoPrincipal.cep.replace(/\D/g, "");
      if (cep.length === 8) {
        axios
          .get(`https://viacep.com.br/ws/${cep}/json/`)
          .then(response => {
            if (!response.data.erro) {
              const { logradouro, bairro, localidade, uf } = response.data;
              this.value.enderecoPrincipal.logradouro = logradouro;
              this.value.enderecoPrincipal.bairro = bairro;
              this.value.enderecoPrincipal.uf = uf;
              // Limpa município anterior antes de carregar novos
              this.value.enderecoPrincipal.municipioId = null;
              this.value.enderecoPrincipal.municipioNome = "";

              const selectedUf = this.ufs.find(u => u.sigla === uf);
              if (selectedUf) {
                this.municipioSelectLoader = true;
                this.$store
                  .dispatch(FETCH_MUNICIPIOS, selectedUf.id)
                  .then(municipiosData => {
                    if (municipiosData && municipiosData.length > 0) {
                      const mun = municipiosData.find(
                        m => m.nome.toUpperCase() === localidade.toUpperCase()
                      );
                      if (mun) {
                        this.value.enderecoPrincipal.municipioId = mun.id;
                        this.value.enderecoPrincipal.municipioNome = mun.nome;
                        this.$forceUpdate();
                      }
                    }
                  })
                  .finally(() => {
                    this.municipioSelectLoader = false;
                  });
              }
            }
          })
          .catch(error => {
            console.error("Erro ao buscar CEP:", error);
          });
      }
    }
  },
  emits: ["validate-field"]
};
</script>

<style scoped>
.full-width {
  width: 100%;
}

.row-align-bottom {
  display: flex;
  align-items: flex-end;
}

.checkbox-col {
  display: flex;
  align-items: flex-start;
  padding-bottom: 22px;
}

@media (max-width: 767px) {
  .row-align-bottom {
    flex-wrap: wrap;
  }
  .checkbox-col {
    padding-bottom: 8px;
    min-height: auto;
  }
}
</style>
